import React, {  useState } from 'react';

import { FormattedMessage } from 'react-intl';

import { ILuxuryHome } from '@share/common-types';

import { ImagesQuantitySvg, FullScreenSvg } from '@assets';

import { CondoImagesSlider } from '../../../condo/condo-details/condo-image-slider';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
}

export const LuxuryHomesDetailsImages: React.FC<IProps> = ({ home }) => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const showSlider = (index: number): void => {
    setIsModalVisible(true);
    setStartIndex(index);
  };

  const handleCancel = (): void => {
    setIsModalVisible(false);
  };

  const mainImage = home?.media?.[0]?.url || home?.thumb;
  const hasMoreImages = home?.media?.length > 1;

  const homeName = home?.title?.split(',')?.[0];

  return (  
    <div className="luxury-homes-details__image">
      <div className="luxury-homes-details__image-item" style={{ backgroundImage: `url(${mainImage})` }}>
        {hasMoreImages && 
          <div className="condo-images-description__middle" style={{ background: 'unset' }}>
            <div
              className="condo-images-description__btn-hover-wrapper"
              onClick={() => showSlider(0)}
            >
              <FullScreenSvg />
              <span className="condo-images-description__btn-hover-text">
                <FormattedMessage id="full.view" />
              </span>
            </div>
          </div>}
        

        {!!home?.media?.length && (
          <div className="condo-images-description__images-quantity" style={{ top: 'unset', bottom: 15 }}>
            <ImagesQuantitySvg />
            <span className="condo-images-description__images-quantity-text">
              {home?.media?.length}+
            </span>
          </div>)}
      </div>

      <CondoImagesSlider
        media={home?.media}
        onCancel={handleCancel}
        visible={isModalVisible}
        title={homeName}
        startIndex={startIndex}
        isVideoError
      />
    </div>
  );
};
